import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Loading from '../components/Loading';

function LoadingSession() {
  return <Loading variant="page" label="" />;
}

export function ProtectedRoute({ children }) {
  const { user, initialized } = useAuth();
  if (!initialized) return <LoadingSession />;
  return user ? children : <Navigate to="/login" replace />;
}

export function PublicOnlyRoute({ children }) {
  const { user, initialized } = useAuth();
  if (!initialized) return <LoadingSession />;
  return user ? <Navigate to="/" replace /> : children;
}
